import { atom } from "jotai";
export const cargosAtom = atom([]);
export const responsablesAtom = atom([]);
export const responsableSeleccionadoAtom = atom (undefined);
export const postulantesAtom = atom([]);
export const postulanteSeleccionadoAtom = atom(undefined);
export const postulantesAgregadosAtom =atom ([]);
export const convocatoriaSeleccionadaIdAtom =atom(undefined);
export const postulantesConvocatoriaAtom= atom([]);
export const loadingAtom = atom(false);